import styled from 'styled-components/macro';
import { pxToRem } from '../../utils';
import Button from '../../Components/Button/Button';

export const StyledKeepARecord = styled.div`
    width: 100%;

    input {
        display: block;
        margin-top: ${pxToRem(8)};
    }

    h2, h3, h4, h5, h6 {
        margin-bottom: ${pxToRem(16)};
    }
`;

StyledKeepARecord.IconButton = styled(Button)`
    text-decoration: none;
    transition: fill 0.5s ease;
    margin-top: ${pxToRem(16)};

    svg {
        width: ${pxToRem(16)};
        height: ${pxToRem(16)};
        position: relative;
        top:  ${pxToRem(2)};
        right: ${pxToRem(8)};
    }
`;

StyledKeepARecord.IconButtonLinkWrapper = styled.div`
    display: flex;
    margin-bottom: ${pxToRem(16)};

    &:last-child {
        margin-bottom: 0;
    }

    svg {
        width: ${pxToRem(24)};
        height: ${pxToRem(24)};
        margin-right: ${pxToRem(8)};
    }
`;

export default StyledKeepARecord;
